




























































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { Tag } from '@/models/tag';
import { GradeClass, SchoolClass } from '@/models/school-class/school-class';
import { GEnum } from '@/constants/enum.defination';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { StudentSearch } from '@/models/student/student-search';

@Component({
  name: 'GStudentFilter',
  computed: {},
  methods: {},
})
export default class GStudentFilter extends mixins(GPageBase) {
  timer: number;
  // 全クラス検索が可能か判定フラグ（一般教員権限時に使用）
  canDisplayAllClass: boolean = true;

  @Prop({ default: true }) isSearchName: boolean;
  @Prop({ default: false }) isStudentNumber: boolean;

  isSearchLoading: boolean = false;
  selectedTagIDs: number[] = [];
  tmpTagIDs: Set<number> = new Set<number>();

  async mounted() {
    await schoolClassModule.fetchGrades();
    schoolClassModule.fetchSchoolClasses();

    // 一般権限の場合は、自分が担当する学年、クラスの最初のものを表示（全学年は選択できない）
    if (this.isRoleNormal) {
      this.grade = this.schoolGrades.find((gradeClass: GradeClass) => {
        return !gradeClass.disabled;
      }).grade;
      this.handleGrade(this.grade);
    }

    if (this.tags.length > 0) {
      // 一旦保存
      this.tmpTagIDs = this.tags.reduce((result: Set<number>, tag: Tag) => {
        if (tag.flg) {
          result.add(tag.tagID);
        }
        return result;
      }, new Set<number>());
    }

    studentFilterModule.fetchTags().then(() => {
      if (this.tmpTagIDs.size > 0) {
        // 保存内容反映
        this.tags = this.tags.map((tag: Tag) => {
          if (this.tmpTagIDs.has(tag.tagID)) {
            tag.flg = true;
          }
          return tag;
        });
      }
    });
  }

  get tags(): Tag[] {
    return studentFilterModule.tags.sort((a: Tag, b: Tag) => {
      return a.tagContent > b.tagContent ? 1 : -1;
    });
  }

  set tags(value: Tag[]) {
    studentFilterModule.setTags(value);
  }

  get grade(): number {
    return studentFilterModule.grade;
  }

  set grade(value: number) {
    studentFilterModule.setGrade(value);
  }

  get isShowAllGrade(): boolean {
    // 一般権限の場合 -> 非表示
    // 管理者権限（またはIGS管理者権限）の場合 -> 表示
    return this.isRoleNormal ? false : true;
  }

  get schoolClassID(): number {
    return studentFilterModule.schoolClassID;
  }

  set schoolClassID(value: number) {
    studentFilterModule.setSchoolClassID(value);
  }

  get searchWord(): string {
    return studentFilterModule.searchWord;
  }

  set searchWord(value: string) {
    studentFilterModule.setSearchWord(value.replace(/　/g, ' '));
  }

  get targetType(): number {
    return studentFilterModule.targetType;
  }

  set targetType(value: number) {
    studentFilterModule.setTargetType(value);
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  set targetID(value: number) {
    studentFilterModule.setTargetID(value);
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  isResponsibleSchoolClass(schoolClassID: number) {
    return this.$store.state.account.isResponsibleSchoolClass(schoolClassID);
  }

  get schoolClassesByGrade(): Map<number, SchoolClass[]> {
    return schoolClassModule.schoolClassesByGrade;
  }

  get schoolClasses(): SchoolClass[] {
    if (this.isRoleNormal) {
      return schoolClassModule.schoolClasses.map((s: SchoolClass) => {
        if (!this.isResponsibleSchoolClass(s.schoolClassID)) {
          s.selected = true;
        }
        return s;
      });
    }
    return schoolClassModule.schoolClasses;
  }

  get studentNumber(): string {
    return studentFilterModule.studentNumber;
  }

  set studentNumber(value: string) {
    studentFilterModule.setStudentNumber(value);
  }

  get schoolGrades(): GradeClass[] {
    const grades: number[] = schoolClassModule.grades || [];

    if (this.isRoleNormal) {
      return grades.map((grade: number) => {
        const gradeClass: GradeClass = new GradeClass().deserialize({ grade });
        const schoolClasses: SchoolClass[] = this.schoolClassesByGrade.get(grade) || [];
        if (!schoolClasses.some((s: SchoolClass) => this.isResponsibleSchoolClass(s.schoolClassID))) {
          gradeClass.disabled = true;
        }
        return gradeClass;
      });
    }
    return grades.map((grade: number) => {
      return new GradeClass().deserialize({ grade });
    });
  }

  get canSearchSubmit(): boolean {
    return this.grade > -1 && this.schoolClassID > -1;
  }

  handleSchoolClass(schoolClassID: number): void {
    console.log(`In handleSchoolClass method! grade: ${this.grade} schoolClassID: ${this.schoolClassID}`);
    if (this.grade === 0 && schoolClassID === 0) {
      // 全学年全クラス 検索
      this.targetType = 0;
      this.targetID = 0;
    } else if (this.grade > 0 && schoolClassID === 0) {
      // 学年指定、全クラス 検索
      this.targetType = GEnum.TargetType.Grade;
      this.targetID = this.grade;
    } else if (this.grade > 0 && schoolClassID > 0) {
      // 学年指定、クラス指定 検索
      this.targetType = GEnum.TargetType.Class;
      this.targetID = schoolClassID;
    }
    console.log(`In handleSchoolClass method! targetType: ${this.targetType} targetID: ${this.targetID}`);
  }

  handleGrade(grade: number): void {
    if (grade) {
      if (this.isRoleNormal) {
        // 一般教員が全クラス検索が可能かどうかを判定する
        //   すべてのクラスが担当である場合、全クラス検索が可能
        this.canDisplayAllClass = this.schoolClasses.filter((s: SchoolClass) => s.grade === grade).every((s: SchoolClass) => this.isResponsibleSchoolClass(s.schoolClassID));
        this.schoolClassID = this.schoolClasses.find((schoolClass: SchoolClass) => this.isResponsibleSchoolClass(schoolClass.schoolClassID) && schoolClass.grade === grade).schoolClassID;
      } else {
        this.schoolClassID = this.schoolClasses.find((schoolClass: SchoolClass) => schoolClass.grade === grade).schoolClassID;
      }
    } else {
      // 全学年が選択された場合
      this.schoolClassID = 0;
    }

    this.handleSchoolClass(this.schoolClassID);
  }

  handleFormSubmit(): void {
    clearTimeout(this.timer);
    this.isSearchLoading = true;
    // 最後の検索結果を保存する
    studentFilterModule.setSelectedTagIDs(this.selectedTagIDs);
    studentFilterModule.setLatestStudentSearchOptions({
      targetType: this.targetType,
      targetID: this.targetID,
      keyword: studentFilterModule.searchWord,
      selectedTagIDs: studentFilterModule.commaSelectedTagIDs,
      studentNumber: this.studentNumber,
    } as StudentSearch);
    this.timer = window.setTimeout(() => {
      this.$emit('submit');
      this.isSearchLoading = false;
    }, 500);
  }
}
